import { ThemeOptions } from '@mui/material/styles/createTheme';
import { ButtonProps } from '@mui/material/Button';

const style = {
  padding: '10px 16px',
  fontSize: '1rem',
  fontWeight: 700,
  lineHeight: '1.5rem',
  letterSpacing: '.024px',
  textTransform: 'none',
} as Record<string, any>;

export const MuiButtonStyle = {
  variants: [
    {
      props: { variant: 'link' as const },
      style: {
        ...style,
        padding: '0px !important',
        textUnderlineOffset: '5px',
        textDecoration: 'underline !important',
        backgroundColor: 'transparent !important',
      },
    }
  ],
  styleOverrides: {
    root: ({ theme, ownerState }: { theme: ThemeOptions, ownerState: ButtonProps }) => {
      const ownerStateColor = ownerState?.color || 'inherit';
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const palletColor = theme.palette[ownerStateColor];

      if (palletColor && ownerState.variant === 'outlined') {
        return {
          ...style,
          padding: '8px 18px',
          border: `2px solid ${palletColor.main}`,
          borderWidth: '2px !important',
          "&:hover": {
            border: `2px solid ${palletColor.main}`,
          },
          "&:active": {
            border: `2px solid ${palletColor.main}`,
          }
        };
      }
      if (palletColor && ownerState.variant === 'contained') {
        return {
          ...style,
          '&[disabled]': {
            opacity: 0.3,
            color: palletColor.contrastText,
            backgroundColor: palletColor.main,
          },
        };
      }
      if (palletColor && ownerState.variant === 'link') {
        return {
          ...style,
          color: palletColor.main,
          '&:hover': {
            color: palletColor.light,
          },
          "&:active": {
            color: palletColor.dark,
          }
        };
      }
      return style;
    }
  }
};

declare module '@mui/material/Button' {

  interface ButtonPropsVariantOverrides {
    link: true;
  }
}
